import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import React from "react";
import { SetupNative2faRootParamList } from "../../../../types";
import { SetupNative2faFormProvider } from "../../components/SetupNative2faForm/SetupNative2faFormProvider";
import { RemoveNative2faRootScreen } from "../RemoveNative2faRootScreen/RemoveNative2faRootScreen";
import { ListNative2faMethodsScreen } from "./ListNative2faMethodsScreen";
import { Native2faEnterIdentifierScreen } from "./Native2faEnterIdentifierScreen";
import { Native2faMethodSelectScreen } from "./Native2faMethodSelectScreen";
import { Native2faVerifyMfaCodeScreen } from "./Native2faVerifyMfaCodeScreen";

export type SetupNative2faRootScreenProps = StackScreenProps<
  any,
  "SetupNative2faRootScreen"
>;

export const SetupNative2faRootScreen = ({
  navigation,
}: SetupNative2faRootScreenProps) => {
  const Stack = createStackHeaderNavigator<SetupNative2faRootParamList>();

  return (
    <SetupNative2faFormProvider>
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
        }}
      >
        <Stack.Group
          screenOptions={{
            headerShown: true,
            headerLeft: () => <ModalCloseButton type="Back" />,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            title: "",
          }}
        >
          <Stack.Screen
            name="ListNative2faMethodsScreen"
            component={ListNative2faMethodsScreen}
          />
          <Stack.Screen
            name="Native2faMethodSelectScreen"
            component={Native2faMethodSelectScreen}
          />
          <Stack.Screen
            name="Native2faEnterIdentifierScreen"
            component={Native2faEnterIdentifierScreen}
          />
          <Stack.Screen
            name="Native2faVerifyMfaCodeScreen"
            component={Native2faVerifyMfaCodeScreen}
          />
          <Stack.Screen
            name="RemoveNative2faRootScreen"
            component={RemoveNative2faRootScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </SetupNative2faFormProvider>
  );
};
